/**
 * Core lib controller for managing data and views.
 * @constructor
 * @module lib/controller
 */

var Constructor = require('js/vendor/constructor');
var _ = require('underscore');
var Backbone = require('backbone');
var Composer = require('js/lib/composer');


/**
 * Controller state for dispatcher to use
 */
var State = Constructor.extend({
  state: {}, // State data to merge
});

/**
 * Initialize controller state object
 */
State.prototype.initialize = function(page, data) {
  this.page = page;
  this.data = data;
};

/**
 * Core lib Controller
 *
 * @exports Controller
 * @constructor
 * @alias module:lib/controller
 */
var Controller = Constructor.extend().mixes(Backbone.Events);

/**
 * Ref to a controller State constructor
 */
Controller.State = State;

/**
 * Store a reference to the application managing this controller
 * @type {module:lib/app}
 */
Controller.prototype.app = null;

/**
 * Controller initializer
 * @constructs Controller
 * @param {module:lib/app} app The managing application
 */
Controller.prototype.initialize = function(app) {
  // Set app ref
  this.app = app;

  // Create instance of composer attached to the controller
  this.composer = new Composer(this);
};

/**
 * Controller destructor
 */
Controller.prototype.destroy = function() {
  this.stopListening();

  // Force invalidation of all composer definitions
  this.composer.invalidate(true);
};

Controller.prototype.newState = function(page, data, tracking = {}) {
  data = _.extend({}, this.state, data, { tracking });

  return new State(page, data, tracking);
};

module.exports = Controller;



// WEBPACK FOOTER //
// ./app/assets/js/lib/controller.js